/**
 * Lo que la pantalla «API Keys» ofrece para probar y copiar (plan 270, tarea 4):
 * la carga del catálogo y el stock, los dos por /api/v1 (vencimiento e IPs de
 * la clave, límite por plan y registro de accesos).
 *
 * Ventas y precios de la competencia no se ofrecen: Prixia no se los pide al
 * cliente en esta ronda (Sebastián, 6-oct). Sus rutas viejas siguen andando.
 */

export type ClaveDeCarga = 'products' | 'stock';

export interface EndpointDeCarga {
  path: string;
  label: string;
  bodyKey: string;
  example: string;
}

/** El mismo criterio que la guía del cliente y Swagger (spec 265, D4). */
export const AVISO_IMPUESTOS =
  'Precio y costo van con impuestos incluidos, comparables con el precio al público de la competencia.';

export function endpointsDeCarga(): Record<ClaveDeCarga, EndpointDeCarga> {
  return {
    products: {
      path: '/api/v1/catalog/products',
      label: 'Productos',
      bodyKey: 'products',
      example: JSON.stringify(
        {
          products: [
            {
              sku: 'SKU-001',
              name: 'Producto ejemplo',
              currentPrice: 99.99,
              costPrice: 70,
              stock: 100,
            },
          ],
        },
        null,
        2
      ),
    },
    stock: {
      path: '/api/v1/stock',
      label: 'Inventario',
      bodyKey: 'stock',
      example: JSON.stringify({ stock: [{ sku: 'SKU-001', quantity: 50 }] }, null, 2),
    },
  };
}

const TITULOS: Record<ClaveDeCarga, string> = {
  products: 'Cargar productos',
  stock: 'Actualizar stock',
};

export function ejemplosCurlDeCarga(): Array<{
  clave: ClaveDeCarga;
  title: string;
  endpoint: string;
  curl: string;
}> {
  const endpoints = endpointsDeCarga();
  return (Object.keys(endpoints) as ClaveDeCarga[]).map((clave) => {
    const e = endpoints[clave];
    const cuerpo = JSON.stringify(JSON.parse(e.example));
    return {
      clave,
      title: TITULOS[clave],
      endpoint: `POST ${e.path}`,
      curl: `curl -X POST https://tu-dominio.com${e.path} \
  -H "Content-Type: application/json" \
  -H "X-API-Key: tu-api-key-aqui" \
  -d '${cuerpo}'`,
    };
  });
}
